import Vue from 'vue';
import moment from 'moment';
import humanize from './humanize';
import hoursAndMinutes from './hoursAndMinutes';
import formatMinutes from './formatMinutes';
import hourOfDay from './hourOfDay';

Vue.filter('formatDate', value => moment(String(value)).format('MMMM D, YYYY'));
Vue.filter('formatDateShort', value => moment(String(value)).format('M/D/YYYY'));
Vue.filter('formatJobDate', value => moment(String(value), 'YYYYMMDD').format('MMMM D, YYYY'));
Vue.filter('formatJobDateShort', value => moment(String(value), 'YYYYMMDD').format('M/D/YYYY'));

Vue.filter('numberToAmPm', hourOfDay);

Vue.filter('humanize', humanize);
Vue.filter('hoursAndMinutes', hoursAndMinutes);
Vue.filter('formatMinutes', formatMinutes);

Vue.filter('phoneNumber', (value) => {
  let phone = value;
  const displayMode = 'noParens';
  if (!phone || !phone.substr) {
    return phone;
  }

  if (phone.startsWith('+1')) {
    phone = phone.substr(2);
  }

  if (phone.length !== 10) {
    return phone;
  }

  let areaCodeComponent;

  if (displayMode === 'noParens') {
    areaCodeComponent = `${phone.substr(0, 3)}-`;
  } else {
    areaCodeComponent = `(${phone.substr(0, 3)}) `;
  }

  return `${areaCodeComponent}${phone.substr(3, 3)}-${phone.substr(6, 4)}`;
});

Vue.filter('currency', (value) => {
  if (typeof value !== 'number') {
    return value;
  }

  if (value < 0) {
    return `-$${Math.abs(value).toFixed(2)}`;
  }

  return `$${value.toFixed(2)}`;
});
